import Vue from 'vue'
import VueRouter from 'vue-router'

import AppNews from '../components/AppNews'
import AppAnnouncements from '../components/AppAnnouncements'
import AppConfig from '../components/AppConfig'
import AppRoles from '../components/AppRoles'
import ApprovalIndex from '../components/production/approvals/Index'
import ApprovalManagement from '../components/production/approvals/Management'
import AccessIndex from '../components/production/AccessIndex'         // deprecate
import ActivityLog from '../components/human_resources/ActivityLog'
import BundleIndex from '../components/production/bundles/BundleIndex'
import BundleShow from '../components/production/bundles/BundleShow'
import CardTransactionIndex from '../components/production/cardTransactions/Index'
import CourseIndex from '../components/production/Courses/CourseIndex'
import ClientIndex from '../components/production/clients/ClientIndex'
import ClientShow from '../components/production/clients/ClientShow'
import ClientNew from '../components/production/clients/ClientNew'
import ClientUpdate from '../components/production/clients/ClientUpdate'
import ColorIndex from '../components/production/colors/Index'
import ColorShow from '../components/production/colors/Show'
import ContractorIndex from '../components/contractors/ContractorIndex'
import ContractorShow from '../components/contractors/ContractorShow'
import ConfiguratorStepLayout from '../components/production/configurators/ConfiguratorStepLayout'
import Distribution from '../components/contractors/Distribution'
import DrawingRequestIndex from '../components/production/drawingRequests/DrawingRequestIndex'
import DrawingRequestShow from '../components/production/drawingRequests/DrawingRequestShow'
import ExternalData from '../components/ExternalData'
import EmployeeIndex from '../components/human_resources/EmployeeIndex'
import EmployeeNew from '../components/human_resources/EmployeeNew'
import EmployeeShow from '../components/human_resources/EmployeeShow'
import EmployeeVacations from '../components/human_resources/EmployeeVacations'
import HR from '../components/human_resources/index'
import HRConfig from '../components/human_resources/Config'
import HRReports from '../components/human_resources/Reports'
import InactiveEmployeeIndex from '../components/human_resources/InactiveEmployeeIndex'
import InactiveEmployeeShow from '../components/human_resources/InactiveEmployeeShow'
import ItemIndex from '../components/production/items/ItemIndex'
import ItemShow from '../components/production/items/ItemShow'
import OnlineStoreQuoteIndex from '../components/online_store/QuoteIndex'
import OrgChart from '../components/human_resources/OrgChart'
import Production from '../components/production/index'
import ProjectIndex from '../components/production/projects/ProjectIndex'
import ProjectShow from '../components/production/projects/ProjectShow'
import PurchaseDeliveryLayout from '../components/production/purchaseDeliveries/PurchaseDeliveryLayout.vue'
import PurchaseDeliveryIndex from '../components/production/purchaseDeliveries/Index.vue'
import PurchaseDeliverySearch from '../components/production/purchaseDeliveries/PurchaseDeliverySearch.vue'
import PurchaseDeliveryRegister from '../components/production/purchaseDeliveries/PurchaseDeliveryRegister.vue'
import PurchaseDeliveryValidation from '../components/production/purchaseDeliveries/PurchaseDeliveryValidation.vue'
import PurchaseRequestNew from '../components/production/purchaseRequests/PurchaseRequestNew.vue'
import PurchaseRequestShow from '../components/production/purchaseRequests/PurchaseRequestShow.vue'
import PurchaseRequestIndex from '../components/production/purchaseRequests/Index.vue'
import QuoteIndex from '../components/production/quotes/QuoteIndex'
import QuoteNew from '../components/production/quotes/QuoteNew'
import QuoteShow from '../components/production/quotes/QuoteShow'
import ResourceCenterIndex from '../components/production/ResourceCenter/Index'
import ServiceCallIndex from '../components/production/serviceCalls/Index'
import ServiceCallNew from '../components/production/serviceCalls/New/Index'
import ServiceCallShow from '../components/production/serviceCalls/Show/Index'
import SubmitalIndex from '../components/production/submitals/SubmitalIndex'
import SubmitalShow from '../components/production/submitals/SubmitalShow'
import SubmitalPhotos from '../components/production/submitals/SubmitalPhotos'
import SubmitalDocuments from '../components/production/submitals/SubmitalDocuments'
import SubmitalAdmin from '../components/production/submitals/SubmitalAdmin'
import TicketIndex from '../components/production/tickets/Index'
import TicketLevels from '../components/production/tickets/Levels'
import TicketShow from '../components/production/tickets/Show'
import VacationTicketIndex from '../components/human_resources/VacationTicketIndex'
import VacationTicketShow from '../components/human_resources/VacationTicketShow'
import WarehouseIndex from '../components/production/WarehouseIndex'
import NotFound from '../components/NotFoundComponent'

import distributors from './distributorRoutes'
import installers from './installerRoutes'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Production, name: 'mainPage' },
    { path: '/app/noticias', component: AppNews},
    { path: '/app/anuncios', component: AppAnnouncements },
    { path: '/app/config', component: AppConfig },
    { path: '/app/datos_externos', component: ExternalData },
    { path: '/app/roles', component: AppRoles },

    // Production
    { path: '/app/prod/centro-recursos', component: ResourceCenterIndex, meta: { prodOnly: true }, name: 'centro-recursos' },
    { path: '/app/prod/clientes', component: ClientIndex },
    { path: '/app/prod/clientes/:id', component: ClientShow, props: true },
    { path: '/app/prod/cliente/:id', component: ClientUpdate, name: 'ClientUpdate',  props: true },
    { path: '/app/prod/cliente', component: ClientNew, meta: { prodOnly: true, prodActive: true } },
    { path: '/app/prod/proyectos', component: ProjectIndex, meta: { prodOnly: true } },
    { path: '/app/prod/proyectos/:id', component: ProjectShow, meta: { prodOnly: true }, props: true },
    //
    { path: '/app/prod/accesos/:type', component: AccessIndex, props: true },         // deprecate
    // Colors
    { path: '/app/prod/colores', component: ColorIndex, name: 'ColorIndex', meta: { prodOnly: true } },
    { path: '/app/prod/colores/:id', component: ColorShow, name: 'ColorShow', props: true, meta: { prodOnly: true } },
    // Courses
    { path: '/app/prod/cursos', component: CourseIndex, meta: { prodOnly: true } },
    //
    // Submital, NEXT version of CortinaIndex
    { path: '/app/prod/submitals/index/:configurable_type', component: SubmitalIndex, meta: { prodOnly: true }, props: true, name: 'SubmitalIndex' },

    { path: '/app/prod/submitals/:id(\\d+)', component: SubmitalShow, meta: { prodOnly: true }, props: true, name: 'SubmitalShow' },
    { path: '/app/prod/submitals/:id(\\d+)/fotos', component: SubmitalPhotos, meta: { prodOnly: true }, props: true },
    { path: '/app/prod/submitals/:id(\\d+)/documentos', component: SubmitalDocuments, meta: { prodOnly: true }, props: true },
    { path: '/app/prod/submitals/:id(\\d+)/admin', component: SubmitalAdmin, meta: { prodOnly: true }, props: true },
    { path: '/app/prod/submitals/:id(\\d+)/:step', component: ConfiguratorStepLayout, meta: { prodOnly: true }, props: true, name: 'ConfiguratorStepLayout' },

    // Quotes
    { path: '/app/prod/cotizaciones', component: QuoteIndex, meta: { prodOnly: true } },
    { path: '/app/prod/cotizador', component: QuoteNew, meta: { prodOnly: true } },
    { path: '/app/prod/cotizador/:id', component: QuoteShow, name: 'QuoteShow', props: true, meta: { prodOnly: true }},

    // Inventario module
    { path: '/app/prod/inventario', component: ItemIndex, name: 'ItemIndex' },
    { path: '/app/prod/inventario/bultos', component: BundleIndex },
    { path: '/app/prod/inventario/bultos/:id', component: BundleShow, props: true },
    { path: '/app/prod/inventario/almacenes', component: WarehouseIndex },

    // <Purchase Deliveries Module>
    { path: '/app/prod/inventario/ingreso', component: PurchaseDeliveryLayout, meta: { prodOnly: true },
      children: [
        { name: 'PurchaseDeliveryIndex', path: '/', component: PurchaseDeliveryIndex },
        { name: 'PurchaseDeliverySearch', path: 'busqueda', component: PurchaseDeliverySearch },
        { name: 'PurchaseDeliveryRegister', path: 'registro', component: PurchaseDeliveryRegister },
        { name: 'PurchaseDeliveryValidation', path: 'validacion', component: PurchaseDeliveryValidation }
      ]
    },
    // </Purchase Deliveries Module>
    { path: '/app/prod/inventario/:id', component: ItemShow, name: 'ItemShow', props: true },

    // Card transactions App
    { path: '/app/prod/transacciones', component: CardTransactionIndex, name: 'CardTransactionIndex' },

    // Purchase Request Module
    { path: '/app/prod/solicitud', component: PurchaseRequestNew, meta: { prodOnly: true } },
    { path: '/app/prod/solicitud/:id', component: PurchaseRequestShow, name: 'PurchaseRequestShow', props: true },
    { path: '/app/prod/solicitudes', component: PurchaseRequestIndex, meta: { prodOnly: true } },

    // Service Calls
    { path: '/app/prod/llamadas-servicio', component: ServiceCallIndex, name: 'ServiceCallIndex' },
    { path: '/app/prod/llamadas-servicio/nueva', component: ServiceCallNew, name: 'ServiceCallNew' },
    { path: '/app/prod/llamadas-servicio/:id', component: ServiceCallShow, name: 'ServiceCallShow', props: true },

    // Online Store
    { path: '/app/tienda_online', component: OnlineStoreQuoteIndex },

    // Contractors  // need meta route guards
    { path: '/app/contratistas', component: ContractorIndex },
    { path: '/app/contratistas/:id', component: ContractorShow, props: true },
    { path: '/app/distribucion', component: Distribution },

    ...distributors,
    ...installers,

    // Human Resources
    { path: '/app/rrhh', component: HR, meta: { prodOnly: true }, name: 'rrhh' },
    { path: '/app/rrhh/empleados', component: EmployeeIndex, meta: { prodOnly: true } },
    { path: '/app/rrhh/empleados/nuevo', component: EmployeeNew, meta: { prodOnly: true } },
    { path: '/app/rrhh/empleados/:id', component: EmployeeShow, name: 'EmployeeShow', props: true, meta: { prodOnly: true } },
    { path: '/app/rrhh/empleados/:id/vacaciones', component: EmployeeVacations, props: true, meta: { prodOnly: true } },
    { path: '/app/rrhh/inactivos', component: InactiveEmployeeIndex, meta: { prodOnly: true } },
    { path: '/app/rrhh/inactivos/:id', component: InactiveEmployeeShow, name: 'InactiveEmployeeShow', props: true, meta: { prodOnly: true } },
    { path: '/app/rrhh/organigrama', component: OrgChart, meta: { prodOnly: true } },
    { path: '/app/rrhh/boletas', component: VacationTicketIndex, meta: { prodOnly: true } },
    { path: '/app/rrhh/boletas/:id', component: VacationTicketShow, props: true, meta: { prodOnly: true } },
    { path: '/app/rrhh/actividad', component: ActivityLog, meta: { prodOnly: true } },
    { path: '/app/rrhh/reportes', component: HRReports, meta: { prodOnly: true } },
    { path: '/app/rrhh/config', component: HRConfig, meta: { prodOnly: true }},

    // Tickets
    { path: '/app/tickets', name: 'TicketIndex', component: TicketIndex },
    { path: '/app/tickets/:id', name: 'TicketShow', component: TicketShow },
    { path: '/app/tickets/admin/niveles', component: TicketLevels, meta: { prodOnly: true } },

    // Drawing Requests
    { path: '/app/prod/solicitudes-planos', component: DrawingRequestIndex, name: 'DrawingRequestIndex', meta: { prodOnly: true } },
    { path: '/app/prod/solicitudes-planos/:id', component: DrawingRequestShow, name: 'DrawingRequestShow', props: true, meta: { prodOnly: true } },

    // Approvals
    { path: '/app/aprobaciones', name: 'ApprovalIndex', component: ApprovalIndex },
    { path: '/app/aprobaciones/management', name: 'ApprovalManagement', component: ApprovalManagement },

    // Not found
    { path: '/app/*', component: NotFound, name: 'notFound' }
  ]
})
